// extracted by mini-css-extract-plugin
module.exports = {"banner":"Account_banner__25hXD","bannerContent":"Account_bannerContent__2ANH0","detailsContent":"Account_detailsContent__3-XF9"};